import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Echo from 'laravel-echo';
import router from '@/router'
Vue.use(VueAxios, axios)

import { API_URLS_BOARD } from '@/constants'

/* --------------------------------- ACTIONS -------------------------------- */

// START WEBSOCKET
const listenKanvanChannel_ = (context) => {
    if (!window.Echo) return;

    window.Echo.join("kanban-update").listen('KanbanUpdateEvent', (data) => {
        let message = JSON.parse(data.message)

        if (message.tickets) {
            let cards = message.tickets
            let states = message.states
            // El payload del websocket no trae la fecha del último mensaje
            // (a diferencia de getAllData): preservarla desde las tarjetas
            // actuales para que el badge de tiempo no desaparezca.
            const prev = context.state.cards || []
            if (prev.length) {
                // "fecha" del último mensaje: el evento puede omitirla o traerla
                // vacía ("" / 0 / null). En cualquiera de esos casos preservamos
                // la de la tarjeta actual para que el badge de tiempo no se pierda.
                const hasFecha = v => v !== null && v !== undefined && v !== '' && v !== 0 && v !== '0'
                const prevById = new Map(prev.map(c => [c.id, c]))
                cards = cards.map(c => {
                    const incomingFecha = c.mensaje?.fecha ?? c.fecha
                    if (!hasFecha(incomingFecha)) {
                        const old = prevById.get(c.id)
                        const oldFecha = old?.mensaje?.fecha ?? old?.fecha
                        if (old && hasFecha(oldFecha)) {
                            return { ...c, fecha: old.fecha, mensaje: c.mensaje ?? old.mensaje }
                        }
                    }
                    return c
                })
            }
            context.commit('setAllData', { cards, states })
        } else {
            let states = message.states
            context.commit('updateColumns', states)
        }

    });

}

// GET STATES AND CARDS
const getAllData_ = (context) => {

    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.getAllDataBoard //ANCHOR[id=ALL-DATA]

    return axios.get(url).then(response => {
        let cards = response.data.tickets
        let states = response.data.states
        context.commit('setAllData', { cards, states })
    }).catch((error) => {
        if (error.response.status == 401) router.push('/auth/signin')
        console.log(error.response)
    })


}

// CARDS
const addCard_ = (context, card) => {
    context.commit('addCard', card)

    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.addCardUrl // ANCHOR[id=ADD-CARD]
    const params = {
        params: {
            card: card
        }
    }

    axios.get(url, params).then(response => {

    }).catch((error) => {
        console.log(error.response)
    })
}

const deleteCard_ = (context, card) => {
    //  context.commit('deleteCard', card)

    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.deleteCardUrl // ANCHOR[id=DELETE-CARD]
    const params = {
        params: {
            card: card
        }
    }

    axios.get(url, params).then(response => {

    }).catch((error) => {
        console.log(error.response)
    })
}

const updateCard_ = async (context, card) => {
    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.updateCardUrl + card.id;
    const params = {};
    let array = ["titulo", "departamento", "severidad", "prioridad", "cerrar_automaticamente", "order", "state", "tags", "emailsCC", "estado", "cliente_servicio_id", "cliente_id"]
    const ESTADO_LABEL_MAP = { 'Cerrado': 0, 'En proceso': 1, 'Contestado': 2, 'Resp. cliente': 3, 'Respuesta de cliente': 3, 'Eliminado': 4, 'Abierto': 5 }
    for (const param in card) {
        if (array.includes(param) && card[param] !== null) {
            params[param] = card[param]
        }
    }
    // Normalizar estado: el kanban puede traer string labels ("Cerrado") en vez de códigos numéricos (0)
    if (params['estado'] !== undefined && typeof params['estado'] === 'string' && isNaN(Number(params['estado']))) {
        params['estado'] = ESTADO_LABEL_MAP[params['estado']] ?? params['estado']
    }

    if (card.cliente_id){
        params['cliente_id'] = card.cliente_id;
    }else{
        params['cliente_id'] = null;
    }

    if (card.usuario) {
        params['usuario_id'] = card.usuario.id
    } else {
        params['usuario_id'] = null
    }

    if (card.cliente_servicio_id) {
        params['cliente_servicio_id'] = card.cliente_servicio_id;
    }else{
        params['cliente_servicio_id'] = null;
    }
    try {
        const res = await axios.post(url, params);
        if(res.status != "200"){
            throw new Error("Verifica los campos antes de actualizar.");
        }
        return {
          data: res.data || { message: `Error ${res.status}` },
          error: false,
          status: res.status
        };
      } catch (error) {
        const backendMessage = error.response?.data?.message || error.message;
        return {
          data: { message: backendMessage },
          error: true,
          status: error.response?.status || 0
        };
      }


};
const updateCardsOrder_ = (context, { cards, card }) => {
    //  context.commit('updateCardsOrder', cards)

    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.updateCardsUrl // ANCHOR[id=UPDATE-CARDS]
    const params = {
        id: card.id,
        order: card.order,
        state: card.state
    }

    axios.post(url, params).then(response => {
        // console.log(response)
    }).catch((error) => {
        console.log(error.response)
    })
}

// COLUMNS
const addColumn_ = (context, column) => {
    //  context.commit('addColumn', column)

    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.addColumnUrl // ANCHOR[id=ADD-COLUMN]
    const params = {
        nombre: column
    }

    axios.post(url, params).then(response => {
        // console.log(response)
    }).catch((error) => {
        console.log(error.response)
    })
}

const deleteColumn_ = (context, column) => {
    //  context.commit('deleteColumn', column)

    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.deleteColumnUrl + column // ANCHOR[id=DELETE-COLUMN]

    axios.get(url).then(response => {
        // console.log(response)
    }).catch((error) => {
        console.log(error.response)
    })
}

const updateColumn_ = (context, { column, name }) => {

    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.updateColumnUrl + column // ANCHOR[id=UPDATE-COLUMN] UPDATE COLUMN //
    const params = {
        nombre: name,
    }

    axios.post(url, params).then(response => {
        // console.log(response)
    }).catch((error) => {
        console.log(error.response)
    })
}

const updateColumns_ = (context, states) => {

    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.updateColumnsUrl // ANCHOR[id=UPDATE-COLUMNS] UPDATE COLUMNS //
    const params = {
        states: states
    }

    axios.post(url, params).then(response => {
        // console.log(response)
    }).catch((error) => {
        console.log(error.response)
    })
}


/* ------------------------------- USERS ------------------------------ */
const getAllUsers = (context) => {
    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.getUsers //ANCHOR[id=ALL-DATA]

    return axios.get(url).then(response => {
        let users = response.data.usuarios
        context.commit('setUsers', users);
        return true;
    }).catch((error) => {
        console.log(error.response);
        return false;
    })
}


/* -------------------------------- CLIENTS -------------------------------- */
const getAllClients = (context) => {
    let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.getClients //ANCHOR[id=ALL-DATA]

    return axios.get(url).then(response => {
        let clients = response.data.usuarios
        context.commit('setClients', clients)
    }).catch((error) => {
        console.log(error.response)
    })
}

const getAllClients_ = (context) => {
  let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.getClients_ //ANCHOR[id=ALL-DATA]

  return axios.get(url).then(response => {
      let clients = response.data.usuarios
      context.commit('setClients', clients)
  }).catch((error) => {
      console.log(error.response)
  })
}






export default {
    listenKanvanChannel_,
    getAllData_,

    addCard_,
    updateCard_,
    deleteCard_,
    updateCardsOrder_,

    addColumn_,
    deleteColumn_,
    updateColumns_,
    updateColumn_,

    // USERS
    getAllUsers,

    // CLIENTS
    getAllClients,
    getAllClients_

}
